import * as React from 'react';
import { useMemo } from 'react';

import { createGRN } from 'logic/permissions/GRN';
import { ListGroup, ListGroupItem } from 'components/bootstrap';
import Routes from 'routing/Routes';
import { Link } from 'components/common/router';
import type { EntityBase } from 'components/common/EntityDataTable/types';

import useEntityCollectionStatus from '../hooks/useEntityCollectionStatus';
import type { Collection } from '../types';

type Prop = {
  entity: EntityBase & { title: string };
  entityType: string;
};

const EntityCollectionList = ({ collections }: { collections: Array<Partial<Collection>> }) => {
  const collectionList = useMemo(
    () =>
      collections.map((collection) => (
        <ListGroupItem key={collection.id}>
          <Link to={Routes.pluginRoute('COLLECTIONS_COLLECTIONID')(collection.id)}>{collection.title}</Link>
        </ListGroupItem>
      )),
    [collections],
  );

  return <ListGroup componentClass="ul">{collectionList}</ListGroup>;
};

const EntityCollectionExpandedSection = ({ entity, entityType }: Prop) => {
  const entityGRN = createGRN(entityType, entity.id);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entity.id);

  if (isFetching || isError) {
    return <p>Loading collections...</p>;
  }

  return (
    <>
      <p>
        The {entityType} {entity.title} is associated with the following collections:
      </p>
      <EntityCollectionList collections={data || []} />
    </>
  );
};

const getRenderExpandCollections = (entityType: string) => (entity: any) => (
  <EntityCollectionExpandedSection entity={entity} entityType={entityType} />
);

export const expandedCollectionSections = (entiyType: string) => ({
  collections: {
    title: 'Collections',
    content: getRenderExpandCollections(entiyType),
  },
});

export default EntityCollectionExpandedSection;
